export default __webpack_public_path__ + "static/media/aglio1.beae390d.png";